import { OrderedMap } from "immutable";
export const Questionnaires = new OrderedMap({
    q1: {
        id: 1,
        question: "A ?",
        key: 1,
        answer: null
    },
    q2: {
        id: 2,
        key: 2,
        question: "B ?",
        answer: null
    },
    q3: {
        id: 3,
        key: 3,
        question: "C ?",
        answer: null
    },
    q4: {
        id: 4,
        key: 4,
        question: "D ?",
        answer: null
    }
});